import { c as _c } from "react/compiler-runtime";
import { normalizeAddress } from "@opensea/utils";
import {
// biome-ignore lint/style/noRestrictedImports: this is fine
useAddress as useWalletAddress, useIsReady as useWalletReady } from "@opensea/wallet";
import { useServerWallet } from "@/components/connect/ServerWalletProvider";
export function useAddress() {
  const $ = _c(6);
  const {
    address: serverAddress
  } = useServerWallet();
  const walletAddress = useWalletAddress();
  const walletReady = useWalletReady();
  if (walletReady) {
    let t0;
    if ($[0] !== walletAddress) {
      t0 = walletAddress ? normalizeAddress(walletAddress) : undefined;
      $[0] = walletAddress;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (serverAddress) {
    let t0;
    if ($[2] !== serverAddress) {
      t0 = normalizeAddress(serverAddress);
      $[2] = serverAddress;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  if (walletAddress) {
    let t0;
    if ($[4] !== walletAddress) {
      t0 = normalizeAddress(walletAddress);
      $[4] = walletAddress;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    return t0;
  }
}